export default __webpack_public_path__ + "static/media/moves.65461bb4.svg";